import React, { useEffect, useState } from "react";
import { PanelControl } from "spark-core-dx/components";
import MarketplaceCheckout from "./MarketplaceCheckout";
import { MARKETPLACE_CHECKOUT_OPEN_EVENT } from "../marketplaceCheckout";

const MarketplaceCheckoutPanelHost = () => {
  const [request, setRequest] = useState(null);
  const [footerHost, setFooterHost] = useState(null);

  useEffect(() => {
    const handleOpen = (event) => {
      const offerKey = String(event?.detail?.offerKey || "").trim();
      if (!offerKey) return;

      setRequest({
        offerKey,
        resourceKey: String(event?.detail?.resourceKey || "").trim(),
        showPaymentFollowUp: event?.detail?.showPaymentFollowUp === true
      });
    };

    window.addEventListener(MARKETPLACE_CHECKOUT_OPEN_EVENT, handleOpen);
    return () => window.removeEventListener(MARKETPLACE_CHECKOUT_OPEN_EVENT, handleOpen);
  }, []);

  if (!request) return null;

  const closeCheckout = () => setRequest(null);

  return (
    <PanelControl
      open
      title="Marketplace Checkout"
      onClose={closeCheckout}
      mapToClass="core-layout"
      position="right"
      width={680}
      minWidth={480}
      maxWidth={800}
      resizable
      storageKey="marketplace-checkout-panel-width"
      className="marketplace-checkout-panel"
      contentClassName="marketplace-checkout-panel__content"
      footer={<div ref={setFooterHost} className="marketplace-checkout-panel__footer-host" />}
    >
      <MarketplaceCheckout
        panel
        actionHost={footerHost}
        offerKeyOverride={request.offerKey}
        resourceKeyOverride={request.resourceKey}
        initialShowPaymentFollowUp={request.showPaymentFollowUp}
        onExit={closeCheckout}
      />
    </PanelControl>
  );
};

export default MarketplaceCheckoutPanelHost;
